import { Card } from "@/components/shared/Card";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { T } from "@transifex/react";
import type { Pass } from "ipctg-inflow-types/InFlowDB";
import { FlatList } from "react-native";

export interface PassCardProps {
  pass: Pass;
}

const PassDetailCard = ({ pass }: PassCardProps) => {
  return (
    <Card>
      <VStack className="gap-[12px]">
        <Text className="font-[700] text-[18px] text-typography-900">
          <T _str="Valid at" />
        </Text>
        <VStack className="gap-[4px]">
          <Text className="font-[400] leading-[20px] text-[14px] text-typography-900">{pass.locationName}</Text>
          <Text className="font-[400] leading-[20px] text-[14px] text-typography-900">{pass.locationAddress.address}</Text>
        </VStack>
      </VStack>

      <VStack className="gap-[12px]">
        <Text className="font-[700] text-[18px] text-typography-900">
          <T _str="Pass Details" />
        </Text>
        <FlatList
          data={pass?.passNotes.map((item) => item.replace("{uses}", (pass.maxUses - pass.uses).toString())) ?? []}
          renderItem={({ item }) => <Text className="font-[400] leading-[20px] text-[14px] text-typography-900">{`\u2022 ${item}`}</Text>}
        />
      </VStack>
    </Card>
  );
};

export default PassDetailCard;
